import { RefObject } from 'react';

const OUTBRAIN_REFRESH_DELAY_MS = 50;

export function triggerOutbrainRefresh(
  containerRef: RefObject<HTMLDivElement | null>
): void {
  const win = window as Record<string, any>;
  if (typeof win.OBR?.extern?.researchWidget !== 'function') {
    return;
  }

  try {
    setTimeout(() => {
      if (containerRef.current) {
        win.OBR.extern.researchWidget();
      }
    }, OUTBRAIN_REFRESH_DELAY_MS);
  } catch (e) {
    console.error('Outbrain re-render failed:', e);
  }
}
